import React from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { ShinyButton } from "./Shared";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-bg min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>404 - Page Not Found | a2z Radiology AI</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Return to the a2z Radiology AI homepage."
        />
      </Helmet>
      <div className="max-w-md w-full space-y-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-extrabold text-fg mb-2">404</h1>
          <h2 className="text-3xl font-bold text-fg mb-4">Page Not Found</h2>
        </motion.div>
        <motion.p
          className="text-xl text-fg-muted mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Oops! The page you're looking for doesn't exist.
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center"
        >
          <ShinyButton onClick={() => navigate("/")}>Return to Homepage</ShinyButton>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
